import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { useSmoothScroll } from "../../App";

export default function PackagePrice() {
  const scrollTo = useSmoothScroll();
  return (
    <section id="pricing" data-testid="package-section" className="border-b border-ink/10 bg-cream">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <Reveal>
          <Eyebrow center>Investment</Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <SectionTitle before="Package" accent="Price" center className="mt-7" />
        </Reveal>

        <Reveal delay={0.2}>
          <div
            data-testid="package-card"
            className="mx-auto mt-16 max-w-xl border border-ink/10 bg-ivory p-10 text-center shadow-sm md:p-14"
          >
            <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-fog">Per person · twin-share</p>
            <p className="mt-5 font-serif text-7xl font-light text-ink md:text-8xl">€1,650</p>
            <p className="mt-3 text-[11px] font-medium uppercase tracking-[0.22em] text-saffron">
              All-inclusive · 12 days · 11 nights
            </p>
            <button
              data-testid="package-enquire-button"
              onClick={() => scrollTo("#enquire")}
              className="mt-10 bg-saffron px-9 py-4 text-[11px] font-semibold uppercase tracking-[0.24em] text-forest transition-colors duration-300 hover:bg-ink hover:text-ivory"
            >
              Request a Quote
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <p className="mt-8 text-center text-[11px] uppercase tracking-[0.18em] text-fog">
            Final quote confirmed personally over WhatsApp
          </p>
        </Reveal>
      </div>
    </section>
  );
}
